import { Components } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import styled from "styled-components";
import { CreatePostModalContext } from "../..";
import { API_CALLS } from "../../../../../../../../API/api_calls";
import { useAppSelector } from "../../../../../../../../redux";

const GIF = () => {
  const { setPostContentOrder } = useContext(CreatePostModalContext);
  const { url, post_id, id } = useAppSelector((state) => state.postGIF.postGIF);
  return (
    <Container>
      <Image src={url} />
      <CloseButton>
        <Components.IconButton
          iconType="X"
          disabled={false}
          kind="Floating"
          onClick={() => {
            API_CALLS.POSTGIF.deleteGIFForAPost({
              post_id,
              gif_id: id,
            }).then(() => {
              setPostContentOrder((prev) =>
                prev.filter((type) => type !== "gif")
              );
            });
          }}
          size="XXS"
        />
      </CloseButton>
    </Container>
  );
};

export default GIF;

const Container = styled.div`
  position: relative;
  width: fit-content;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-l"]};
`;
const Image = styled.img`
  width: 140px;
  height: 100%;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  display: block;
`;

const CloseButton = styled.div`
  position: absolute;
  top: -${({ theme }) => theme.spacing["spacing-2"].value}rem;
  right: -${({ theme }) => theme.spacing["spacing-2"].value}rem;
  cursor: pointer;
`;
